<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1Agenda",
  computed: {
    ...mapGetters("bahn1", ["eventProgramm"]),
    programmItems() {
      const items = this.eventProgramm ? this.eventProgramm.ProgrammItems : [];
      return items.filter(
        item => item.Thema || item.Label || item.ReferentInnen
      );
    }
  },
  methods: {
    formatTime(time) {
      return time ? time.slice(0, 5) : "";
    }
  }
};
</script>

<template>
  <div class="agenda" v-if="programmItems.length">
    <table class="agenda-table">
      <thead>
        <tr>
          <th class="col-time">Uhrzeit</th>
          <th class="col-thema">Thema</th>
          <th class="col-referenten">Referent:innen</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in programmItems"
          :key="index"
          :class="{ 'agenda-row--accent': index % 2 === 0 }"
        >
          <td class="cell-time">{{ formatTime(item.Uhrzeit) }}</td>
          <td class="cell-thema">
            <span v-if="item.Label" class="agenda-label">{{ item.Label }}</span
            ><br />
            <span class="agenda-thema">{{ item.Thema }}</span>
          </td>
          <td class="cell-referenten">{{ item.ReferentInnen }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.agenda {
  width: 100%;
  margin-bottom: 56px;
}
.agenda-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "GeometriaLight", sans-serif;
}
.agenda-table th,
.agenda-table td {
  text-align: left;
  vertical-align: top;
  padding: 11px 0px 10px 16px;
}
.agenda-table th {
  letter-spacing: 0.6px;
  font-size: 12px;
}
.agenda-row--accent {
  background: #dcecf7;
}
.agenda-label {
  font-size: 10px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-family: "GeometriaGeometria";
  margin-bottom: 8px;
}
.agenda-thema {
  font-family: "GeometriaMedium";
  letter-spacing: 0.32px;
}
.cell-time {
  width: 10%;
}
.cell-thema {
  width: 45%;
}
.cell-time,
.cell-referenten {
  letter-spacing: 0.32px;
}
</style>
